import {
  Component,
  ContentChildren,
  QueryList,
} from '@angular/core';
import { AccordianItemDirective } from './directives/accordian-item.directive';

@Component({
    selector: 'black-ui-accordian',
    templateUrl: './ui-accordian.component.html',
    styleUrls: ['./ui-accordian.component.css'],
    standalone: false
})
export class UiAccordianComponent {
  @ContentChildren(AccordianItemDirective)
  items!: QueryList<AccordianItemDirective>;

  expanded = new Set<number>();

  toggleState(index: number) {
    if (this.expanded.has(index)) {
      this.expanded.delete(index);
    } else {
      this.expanded.add(index);
    }
  }

  getToggleState(index: number) {
    return this.toggleState.bind(this, index);
  }
}
